module.exports = __webpack_public_path__ + "static/map-491bd45fa9893bc949953d74b6ca17c7.png";